<div class="create-dialog-box scrollable-dialog">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0">Reset Password</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i class="flaticon-close"></i></button>
    </div>
    <form [formGroup]="passwordResetForm" class="form-wrapper">
        <div class="row">
            <div class="col-lg-6 col-md-6 ">
              
            </div>
            <div class="col-lg-6 col-md-6 text-end">
                <button type="button" (click)="generatePass()" [matTooltip]="'Generate Password'"><i class="ri-restart-line" ></i></button>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <label class="d-block fw-semibold">New Password</label>
                    <input type="text" class="input-control" placeholder="New Password" formControlName="password">
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <label class="d-block fw-semibold">Confirm Password</label>
                    <input type="text" class="input-control" placeholder="Confirm Password" formControlName="confirmPassword">
                    <!-- <input type="file" class="input-control"> -->
                </div>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="gray" (click)="close()"><i class="ri-close-fill"></i> Cancel</button>
            <button type="submit" (click)="updatePassword()" ><i class="ri-add-fill"></i> Update</button>
        </div>
    </form>
</div>